/*
 * Copyright (c) 2024. Tooling Team
 */

import { useEffect, useState } from "react";
import { PATHS } from "../utils/constants";
import useEIPMapValueDefinition from "../hooks/useEIPMapValueDefinition";
import { isAdminUser } from "../utils/authz";

export default () => {
  const [submissionFinished, setSubmissionFinished] = useState(false);
  const [submissionErrors, setSubmissionErrors] = useState([]);
  const [submissionHeader, setSubmissionHeader] = useState("");
  const [spawnSubmissionPopup, setSpawnSubmissionPopup] = useState(false);
  const [submissionSubText, setSubmissionSubText] = useState("");
  const [submissionCallback, setSubmissionCallback] = useState(() => () => {});
  const { mapStatus } = useEIPMapValueDefinition();
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [publishButtonDisabled, setPublishButtonDisabled] = useState(true);
  const [submitForReviewDisabled, setSubmitForReviewDisabled] = useState(true);
  const [addButtonDisabled, setAddButtonDisabled] = useState(false);
  const [bulkUploadButtonDisabled, setBulkUploadButtonDisabled] =
    useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      resetButtonOnMapStatus(mapStatus);
    }
    return () => (mounted = false);
  }, [mapStatus]);
  async function handleErrorResponse(response, setSubmissionErrors) {
    if (response.status === 403) {
      window.location.replace(PATHS.forbidden.url);
    }
    // Individual API error handlers
    if (response.status === 404) {
      setSubmissionErrors(["Map not found."]);
      return;
    }
    if (response.status === 422) {
      const json = response.json ? await response.json() : response;
      const errors = [];
      if (json.error) {
        errors.push(json.error);
      } else {
        json.records.forEach((record) => {
          record.errors.forEach((error) => {
            errors.push(error);
          });
        });
      }
      setSubmissionErrors(errors);
      return;
    }
    if (response.message) {
      setSubmissionErrors([response.message]);
    }
  }

  const resetButtonOnMapStatus = (mapState, isEditableVersion) => {
    setSaveButtonDisabled(true);
    setPublishButtonDisabled(!isAdminUser() || mapState !== "REVIEW");
    setSubmitForReviewDisabled(mapState !== "DRAFT");
    setAddButtonDisabled(mapState === "REVIEW" || isEditableVersion === false);
    setBulkUploadButtonDisabled(
      mapState === "REVIEW" || isEditableVersion === false
    );
  };

  return {
    state: {
      submissionFinished,
      setSubmissionFinished,
      submissionErrors,
      setSubmissionErrors,
      submissionHeader,
      setSubmissionHeader,
      spawnSubmissionPopup,
      setSpawnSubmissionPopup,
      submissionSubText,
      setSubmissionSubText,
      submissionCallback,
      setSubmissionCallback,
      saveButtonDisabled,
      setSaveButtonDisabled,
      setPublishButtonDisabled,
      publishButtonDisabled,
      submitForReviewDisabled,
      setSubmitForReviewDisabled,
      addButtonDisabled,
      bulkUploadButtonDisabled,
      setBulkUploadButtonDisabled,
    },
    handleErrorResponse,
    resetButtonOnMapStatus,
  };
};
